import Component from "vue-class-component"
import moduleStore from "./store/extraList"
import Vue from "vue"
import PageState from "./store/state"
import { Toast, Dialog } from "vant"
// import Axios from "axios"
// import { getMediaFileDuration } from '../../utils/file'
import { toast } from "@/utils/util"
import { getQueryString } from "@/utils/location"
import { copy } from '@/utils/util'
import { judgeDeviceType } from "@/utils/device";
import LZString from '../../utils/lz-string.min'
// import {deserialize} from "v8";
/**components**/
@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})

export default class extraListPage extends Vue {
  state = new PageState()
  self: Vue = this
  page = 1
  size = 10
  showTip = false
  durationList = []
  loading = null
	filterType = 0
  pageCount = 0
  tip = ""
	dateFilter = ''
	showPopover=false
	filterDate=""
	maxDate = new Date()
	currentDate = new Date()
  gotoTimer = null
	isSearch = false
	DateShow = false
  textStatusObj={
    0:"正在解析中",
    1:"链接同步中，请稍后",
    2:"正在努力提取中....",
    4:"提取失败",
  }
	filterOption=[
		{ text: '全部类型', value: 0 },
		{ text: '链接', value: 1 },
		{ text: '文件', value: 2 },
	]
	dateOption = [
		{ text: '全部日期', value: '' },
		{ text: '选择日期', value: '1' },
	]
  isAPP = judgeDeviceType.isAPP;
  isIOS = judgeDeviceType.isIOS;
  // activeIcon = require("./images/icon_mute_round_nor.png")
  // inactiveIcon = require("./images/icon_mute_round_sel.png")
  created(moduleData: IinjectDatas) {
    // this.vipPermission = this.vipInfo.types
    this.state = <PageState>moduleData.state
    let ww_token = getQueryString("ww_token")
    let wwid = getQueryString("wwid");
    let source = getQueryString("source")
    let appVersion = getQueryString("appVersion")
    if (ww_token) {
      this.state.ww_token = ww_token
    }
    if(wwid){
      localStorage.setItem("wwid",wwid);
    }
  }

mounted() {
  clearTimeout(this.gotoTimer)
  if (this.state.ww_token) {
    // this.getExtractDurationListFn()
    this.initSearch()
  }
}
  getExtractDurationListFn() {
		this.isSearch=true
    if (!this.durationList || this.durationList.length == 0) {
      this.loading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      })
    }

    let data:any = {
      page: this.page,
      size: this.size,
      day:this.filterDate

    }
    if(this.filterType){
      data.type=this.filterType
    }
    this.$http("getExtractDurationList", data)
      .then((res) => {
				this.isSearch = false
        this.loading.clear()
        this.state.loading = false
        if (res.code == 200) {
          let results = res.data.results || []
          console.log("----res文案提取", results)
          // let results = [];//test
          this.pageCount = res.data.total_pages
          if (this.pageCount == 1) {
            this.tip = "没有更多了~"
						this.state.finished=true
          }
          if (this.pageCount == 0) {
            this.tip = "暂无数据"
						this.state.finished=true
            this.showTip = true
          }
				
          if (results.length == 0) {
            if (this.page == 1) {
              ;(this.durationList = []), (this.showTip = true)
            }
            return
          }
          results.forEach((item) => {
            item.createdAt = this.expiredAtMap(item.createdAt)
            let duration = item.duration
              ? this.secondToDateArr(item.duration, "miao")
              : [0, 0, 0]
            item.duration = duration
            return item
          })

          this.showTip = false
          if (this.page > 1) {
            let durationListAll = [...this.durationList, ...results]
            this.durationList = durationListAll
          } else {
            this.durationList = results
          }
					if(this.page==this.pageCount){
						this.state.finished=true
					}
        } else {
          toast("服务出错，请稍后重试")
          this.state.finished=true
          this.loading.clear()
          this.page = 1
          this.pageCount = 0
        }
      })
      .catch((err) => {
        toast("服务出错，请稍后重试")
        this.state.finished=true
        this.loading.clear()
				this.isSearch = false
        this.state.loading = false
        console.log("err", err)
      })
  }
	addExtra(){

	}
  expiredAtMap(v) {
    if (this.isIOS) {
      return v.split('.')[0]?.replace('T', ' ') || ""
    } else {
      return new Date(v).format("yyyy.MM.dd hh:mm:ss") || ""
    }

  }

 dubbing(text:string) {
  let vm = this;
  if (this.isAPP) {
    let resultTxt = encodeURIComponent(LZString.compressToBase64(text));
    let resultObj = { 'copyText': resultTxt };
    let switchToEditPage: any = (<any>window).switchToEditPage
    switchToEditPage.postMessage(JSON.stringify(resultObj))
  } else {
    localStorage.setItem("articleContent", text);
    sessionStorage.removeItem("articleId");
    vm.$navigateTo({
      url: "/pages/audition-web/audition-web?articleContent=true",
    })
  }
    //校验token
        //内容放到storage
 
        // this.$navigateTo({
        //   url: `/pages/audition-web/audition-web?from=tool&articleContent=${encodeURIComponent(text)}`,
        // });
    
  }
  cancelExtract(item) {
    this.$http("deleteExtractDuration",{taskId:item.taskId}).then((res: any) => {
      if(res.code==200){
        Toast('任务已取消')
        this.initSearch()
      }else{
        Toast('任务取消失败')
      }
    })
    return

  }
  copyspan(text:string) {
    copy(text).then(() => {
      toast("内容已复制");
    });
  }
  secondToDateArr(time, type) {
    if (time === 0) {
      return "0分钟"
    } else {
      time = type ? time : time / 1000
      var h = Math.floor(time / 3600)
      var m = Math.floor((time / 60) % 60)
      var s = Math.floor(time % 60)
      return [h, m, s]
    }
  }
  _checkToken() {
    return new Promise((resolve, reject) => {
      if (!this.state.ww_token) {
        reject()
        return
      }
      return resolve(true)

     
    })
  }
  deleteItem(e) {
    let id = e.currentTarget.dataset.id
    let vm = this
    let token = this.state.ww_token
    let data = { token: token }
    this._checkToken().then((res: any) => {
      if (res.err_code != 306 && res.err_code != -2) {
        Dialog.confirm({
          title: `是否确认删除`,
          confirmButtonText: "确定",
          message: `删除后无法恢复?`,
          className: "pop-confirm",
          getContainer: "#page-audition",
          cancelButtonText: "取消",
        })
          .then(() => {
            if (res.confirm) {
              this.$http("deleteExtractDuration", { recordId: id }).then(
                (res) => {
                  if (res.code === 200) {
                    toast("删除成功")
                    this.page = 1
                    this.getExtractDurationListFn()
                  }
                }
              )
            } else if (res.cancel) {
              console.log("用户点击取消")
            }
          })
          .catch(() => {
            // on cancel
            return false
          })
      }
    })
  }
	onDateConfirm(){
  this.DateShow = false;
  this.filterDate = new Date(this.currentDate).format('yyyy-MM-dd')
	this.initSearch()
	
	}
	filterChange(){
		console.log(this.filterType);
		this.initSearch()
	}
	initSearch(){
		this.durationList=[]
		this.state.finished=false
		this.state.loading=false
		this.page = 1
		this.getExtractDurationListFn()
		this.page++

	}
  goToExtract(type) {
    //校验token是否过期
    let token = this.state.ww_token
   
    if (!token) {
      this.$navigateTo({
        url: "/pages/login/login",
      })
      return
    }
    if(this.isAPP){
      let pathType=type == 1 ? "switchToLinkCopyExtraction" : "switchToFileCopyExtraction"
      let switchToPage: any = (<any>window)[pathType]
			switchToPage.postMessage('')
    }else{
      this.$router.push({
        path: "/fileExtract",
        query: {
          upType: type == 1 ? "link" : "video",
          ww_token: this.state.ww_token,
        },
      })
    }
  
		// let url=`/#/fileExtract?upType=${type==1?'link':'video'}&ww_token=${this.state.ww_token}`
    // location.href=url
		// let path=`/webviews/pages/webview/webview?from=tool&to=extract&url=${encodeURIComponent(url)}`
    // this._checkToken().then((res: any) => {
    //   if (res.err_code != 306 && res.err_code != -2) {
    //     this.$navigateTo({
    //       url:path,
    //     })
    //   }
    // })
  }
  
	dateChange(type){
		let dateItem = this.$refs.dateItem as any
		dateItem.toggle();
		if(type == 'all'){
			this.filterDate = ''
      this.DateShow = false;
	    this.initSearch()
		}else if(type=='single'){
			this.currentDate=new Date()
			this.DateShow = true
		}

	}
  onLoad() {
    this.state.loading = true
    if (this.isSearch) {
    	return
    }
    
    this.state.finished = false
    this.getExtractDurationListFn()
		this.page++
		
  }
}
